import { Suspense } from "react";
import Loading from "../../../common/components/ui/loading/Loading";
import GenericTable from "../../../common/components/ui/table/GenericTable";
import {
  TableFilters,
} from "../../../common/components/ui/table/TableFilters";
import TableFooter from "../../../common/components/ui/table/TableFooter";
import { STATUS_LABELS_VEHICLES, getStatusLabelsVehicle } from "../../../types/vehicle.type";
import { getCompanySigla } from "@/common/helpers/company.helpers";
import { useGetAuditsVehiclesMaintenance } from "../hooks";
import { format } from "date-fns";
import { useAuditMaintenanceState } from "@/common/states/store/slices/auditsMaintenanceSlice";

const headers = {
  companyId: "Cidade",
  licensePlate: "Placa",
  model: "Modelo",
  status: "Status",
  dateLastMaintenance: "Data Últ. Manutenção",
};

export const AuditsTableVehiclesMaintenance = () => {
  const { audits, isLoading, totalItems } = useGetAuditsVehiclesMaintenance();
  const { setFilters, setPage, itemsPerPage, page } = useAuditMaintenanceState();

  const handleFilterChange = (
    newFilters
  ) => 
    {
    setFilters(newFilters);
  };

  return (
    <Suspense fallback={<Loading />}>
      <div className="table-section">
        <TableFilters
          dashboardHeader="Manutenções Atrasadas"
          placeholder="Digite a placa do veículo"
          statusOptions={STATUS_LABELS_VEHICLES}
          onSearch={handleFilterChange}
          entity="vehicle-trackers"
          tableData={audits}
        />

        <GenericTable
          headers={headers}
          data={audits}
          renders={
            {
              companyId: (companyId: string) => (
                 getCompanySigla(companyId as string)
              ),
              status: (_, data) => (
                  <span
                    className="flex justify-center gap-2"
                    style={{ fontSize: "15px" }}
                  >
                    {getStatusLabelsVehicle(data.status)}
                  </span>
              ),
              dateLastMaintenance: (_, data) => (
                  <span
                    className="flex justify-center gap-2"
                    style={{ fontSize: "15px" }}
                  >
                  {!data.lastMaintenanceDate ? 'Nenhuma manutenção registrada' : 
                    format(new Date(data.lastMaintenanceDate as string), 'dd/MM/yyyy')
                  }
                  </span>
              )
              //eslint-disable-next-line @typescript-eslint/no-explicit-any
            } as any
          }
          entity="vehicleTrackers"
        />

        {isLoading && <Loading />}

        <TableFooter
          page={page}
          totalItems={totalItems}
          itemsPerPage={+(itemsPerPage ?? 10)}
          goToPage={setPage}
        />
      </div>
    </Suspense>
  );
}
